import { Component, inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PaySessionStatistics } from '../../../smoothr-web-app-core/models/PaySessionStatistics';
import { TipSelectorValue, TipType } from '../../components/tip-selector/tip-selector.component';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { getAbsolutValueFromTipSelection } from '../../../smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-tip-selection-modal',
	standalone: false,
	templateUrl: './tip-selection-modal.component.html',
	styleUrls: ['./tip-selection-modal.component.scss'],
})
export class TipSelectionModalComponent {
	@Input() totalPrice = 0;
	@Input() itemCount = 0;
	paySessionStatistics: PaySessionStatistics | null = null;
	selectedTip: TipSelectorValue = {
		value: 0,
		type: TipType.RELATIVE,
		icon: '',
	};
	selectionHappened = false;
	private repositoryService = inject(RepositoryService);
	totalTipText = this.repositoryService.currencyFormat.format(getAbsolutValueFromTipSelection(this.totalPrice, this.selectedTip));
	private modalCtrl = inject(ModalController);

	get formattedSelected(): string {
		return this.repositoryService.currencyFormat.format(this.paySessionStatistics?.selectedTotalPrice ?? 0);
	}

	static async show(
		modalCtrl: ModalController,
		totalPrice: number,
		itemCount: number,
		paySessionStatistics: PaySessionStatistics | null
	): Promise<TipSelectorValue> {
		const modal = await modalCtrl.create({
			component: TipSelectionModalComponent,
			showBackdrop: true,
			backdropDismiss: true,
			cssClass: 'payment-sheet-modal',
			componentProps: {
				totalPrice,
				itemCount,
				paySessionStatistics,
			},
		});

		await modal.present();

		const { data } = await modal.onDidDismiss();
		return data;
	}

	selectTip(tip: TipSelectorValue) {
		this.selectionHappened = true;
		this.selectedTip = tip;
		this.totalTipText = this.repositoryService.currencyFormat.format(getAbsolutValueFromTipSelection(this.totalPrice, tip));
	}

	async confirm() {
		this.modalCtrl.dismiss(this.selectedTip);
	}

	close() {
		this.modalCtrl.dismiss();
	}
}
